import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ResizableBox } from 'react-resizable';
import { CnTab, CnTabItem } from '@alife/cn-ui';
import { find as _find } from 'lodash-es';
import classNames from 'classnames';
import { ParentNodeResizeDetector } from '@/utils/resize-detector';
import '../scss/tab-bar.scss';
import 'react-resizable/css/styles.css';
const clsPrefix = `cn-editor-tab-bar`;
const minHeight = 48;
var TabBarMode;
(function (TabBarMode) {
    TabBarMode["resizable"] = "resizable";
    TabBarMode["static"] = "static";
})(TabBarMode || (TabBarMode = {}));
const TabBar = (props) => {
    const { tabs, draggable, collapsed } = props;
    const [activeKey, setActiveKey] = useState();
    const [currentTab, setCurrentTab] = useState();
    const [maxHeight, setMaxHeight] = useState(0);
    const [resizableHeight, setResizableHeight] = useState(minHeight);
    const [containerHeight, setContainerHeight] = useState(0);
    const dragRef = useRef(null);
    const mode = useMemo(() => {
        if (draggable) {
            return TabBarMode.resizable;
        }
        return TabBarMode.static;
    }, [draggable]);
    useEffect(() => {
        setMaxHeight(containerHeight);
        if (collapsed) {
            setResizableHeight(minHeight);
            return;
        }
        setResizableHeight(containerHeight / 3);
    }, [collapsed, containerHeight]);
    const onResize = useCallback((e) => {
        setContainerHeight(e.clientHeight);
    }, []);
    useEffect(() => {
        const detector = new ParentNodeResizeDetector(dragRef.current, onResize);
        return () => {
            detector.uninstallElementResizeDetector();
        };
    }, []);
    useEffect(() => {
        if (tabs && tabs.length) {
            setActiveKey(tabs[0].id);
        }
    }, [tabs]);
    useEffect(() => {
        const current = _find(tabs, (t) => {
            return t.id === activeKey;
        });
        if (current) {
            setCurrentTab(current.content);
        }
    }, [activeKey, tabs]);
    if (!tabs || !tabs.length) {
        return null;
    }
    const renderTabs = () => {
        return (<>
        <div className={`${clsPrefix}-content`}>{currentTab}</div>
        <div className={`${clsPrefix}-tab-container`}>
          <CnTab shape="text" size="small" smartPadding={false} activeKey={activeKey} onChange={(key) => {
                setActiveKey(key);
            }}>
            {tabs?.map((t) => {
                return <CnTabItem key={t.id} title={t.title} className={`${clsPrefix}-tab-item`}/>;
            })}
          </CnTab>
        </div>
      </>);
    };
    if (mode === TabBarMode.resizable) {
        return (<ResizableBox ref={dragRef} className={classNames(clsPrefix, `${clsPrefix}-draggable`)} height={resizableHeight} axis="y" resizeHandles={['n']} minConstraints={[Infinity, 48]} maxConstraints={[Infinity, maxHeight]} handle={<div className={`${clsPrefix}-handle`}/>}>
        {renderTabs()}
      </ResizableBox>);
    }
    return <div className={clsPrefix}>{renderTabs()}</div>;
};
export default TabBar;
